import { ganttDay } from './operationGantt.js'

const DAY = 86400000
const dateOf = day => new Date(day * DAY)
export const mondayOf = day => day - (dateOf(day).getUTCDay() + 6) % 7

export function calendarDays(cursor, mode) {
  if (mode === 'week') return Array.from({ length: 7 }, (_, i) => mondayOf(cursor) + i)
  const date = dateOf(cursor)
  const first = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 1) / DAY
  const last = Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 0) / DAY
  const start = mondayOf(first)
  return Array.from({ length: Math.ceil((last - start + 1) / 7) * 7 }, (_, i) => start + i)
}

export function moveCalendar(cursor, mode, direction) {
  if (mode === 'week') return cursor + direction * 7
  const date = dateOf(cursor)
  return Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + direction, 1) / DAY
}

export function groupCalendarTasks(tasks) {
  const byDay = new Map(), unscheduled = []
  for (const task of tasks) {
    const day = ganttDay(task.prazo)
    if (day == null) { unscheduled.push(task); continue }
    if (!byDay.has(day)) byDay.set(day, [])
    byDay.get(day).push(task)
  }
  const timeOf = value => /^\d{4}-\d{2}-\d{2}$/.test(value) ? -Infinity : new Date(value).getTime()
  for (const entries of byDay.values()) entries.sort((a, b) => timeOf(a.prazo) - timeOf(b.prazo) || a.titulo.localeCompare(b.titulo, 'pt-BR'))
  return { byDay, unscheduled }
}

export function calendarTaskState(task, today) {
  if (task.status === 'concluido') return 'done'
  const day = ganttDay(task.prazo)
  if (task.atraso_dias != null || (day != null && day < today)) return 'overdue'
  return day === today ? 'today' : 'future'
}

export function calendarTime(value) {
  if (!value || ganttDay(value) == null || /^\d{4}-\d{2}-\d{2}$/.test(value)) return 'Sem horário'
  return new Date(value).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', timeZone: 'America/Sao_Paulo' })
}
